import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/table/deleted${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/table/deleted`;

export const URL = (tableQuery: TableQuery): RouteDefinition => `${baseRoute}/table/deleted?query=${encodeURIComponent((JSON.stringify(tableQuery)))}`;
